module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Book-Of-Love-The.5c3bedb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Book-Of-Love-The.jpg
// module id = cwFD
// module chunks = 0